<template>
  <div style="height: 100%">
    <h2 style="width: 10%;margin: 0 auto">操作记录</h2>
      <el-scrollbar style="height: 100%">
        <div style="width: 40%;margin: 0 auto;display: grid">
          <el-timeline :reverse="false">
            <el-timeline-item v-for="(list, index) in this.logInfo" :key="index"
                              :timestamp="list.time">
              <el-card>
                <h4> {{ list.logs }}</h4>
                <p>{{ list.name }} 记录于 {{ list.time }}</p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-scrollbar>
    <div style="height: 100px"></div>
<!--    <el-pagination-->
<!--      background-->
<!--      style="margin: 0 auto;justify-content: center;align-items: center;text-align: center;height: 50px"-->
<!--      layout="prev, pager, next"-->
<!--      :total="total"-->
<!--      :current-page="pagenum"-->
<!--      @current-change="pagechange"-->
<!--      :page-size="numperpage">-->
<!--    </el-pagination>-->
  </div>
</template>

<script>
import * as req from '../utils/request'

export default {
  name: 'log',
  data () {
    return {
      logInfo: [],
      total: 0,
      pagenum: 1,
      numperpage: 9999999999999
    }
  },
  created () {
    this.sysLog()
  },
  methods: {
    pagechange (data) {
      this.pagenum = data
      this.sysLog()
    },
    // 获取岗位列表
    sysLog () {
      let msg = {}
      msg.pagenum = this.pagenum - 1
      msg.numperpage = this.numperpage
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.sysLogFn
      sendData.vm = this
      req.Post('user/sysLog', sendData)
    },
    sysLogFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.total = data.data.total - data.data.result.length
      let obj = []
      let s = data.data.result
      for (let i in s) {
        s[i].time = this.getTime(s[i].time)
        obj.push(s[i])
      }
      this.logInfo = obj
    },
    getTime (val) {
      let dateTime = new Date(val)
      let yy = dateTime.getFullYear()
      let mm = dateTime.getMonth() + 1 < 10 ? '0' + (dateTime.getMonth() + 1) : dateTime.getMonth() + 1
      let dd = dateTime.getDate() < 10 ? '0' + dateTime.getDate() : dateTime.getDate()
      let hh = dateTime.getHours() < 10 ? '0' + dateTime.getHours() : dateTime.getHours()
      let mf = dateTime.getMinutes() < 10 ? '0' + dateTime.getMinutes() : dateTime.getMinutes()
      let ss = dateTime.getSeconds() < 10 ? '0' + dateTime.getSeconds() : dateTime.getSeconds()
      return yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
    }
  }

}
</script>

<style scoped>
/deep/.el-scrollbar .el-scrollbar__wrap {overflow-x: hidden;}
</style>



// WEBPACK FOOTER //
// src/page/log.vue